import { useTranslation } from 'react-i18next';
import { WarningTriangle } from 'iconoir-react';
import { EmptyState } from '@/components/ui/empty-state';

interface ProgramsErrorStateProps {
  /** User-friendly English message from the API envelope, if any. */
  message?: string;
}

/**
 * Shown when the program list query fails. Reuses the shared EmptyState shell
 * (same surface as the browse empty state) and surfaces the API message as-is.
 */
const ProgramsErrorState = ({ message }: ProgramsErrorStateProps) => {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={t('programs.browse.error.title')}
      description={message}
      icon={<WarningTriangle />}
    />
  );
};

export default ProgramsErrorState;
